import { Staff } from '@/plugins/api'
import { upsertMany } from '@/helpers'

export default {
  namespaced: true,
  state: {
    managers: [],
    isLoading: false
  },
  actions: {
    async fetchManagers({ commit }, options) {
      const res = await Staff.fetch(options)
      commit('setManagers', res)
    },
    async fetchManager({ commit, state }, { id, options }) {
      const res = await Staff.fetchOne(id, options)
      commit('setManagers', upsertMany(state.managers, res))
    },
    async updateManager({ commit, state }, { id, params, options }) {
      const res = await Staff.update(id, params, options)
      commit('setManagers', upsertMany(state.managers, res))
    },
    async createManager({ commit, state }, { params, options }) {
      const res = await Staff.create(params, options)
      commit('setManagers', upsertMany(state.managers, res))
    },
    async removeManager({ commit, state }, { id, options }) {
      await Staff.remove(id, options)
      commit(
        'setManagers',
        state.managers.filter(i => i.id !== id)
      )
    },
    async swapManager({ commit, state }, { id, params, options }) {
      await Staff.swap(id, params, options)
      commit(
        'setManagers',
        state.managers.filter(i => i.id !== id)
      )
    }
  },
  mutations: {
    setManagers(state, v) {
      state.managers = v
    }
  }
}
